import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DashboardFrame } from '@eforall/dashboard';
import { SearchWidget } from '../../ui/widget';

@Component({
	selector: 'programs-frame',
	standalone: true,
	imports: [
		RouterOutlet,
		DashboardFrame,
		SearchWidget,
	],
	templateUrl: './frame.page.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./frame.page.scss']
})
export class FramePage {

}